import * as React from "react";

import { REACT_APP_SERVER_LINK } from "utils";

export type ServerStatus = "checking" | "online" | "offline";

const HEALTH_URL = REACT_APP_SERVER_LINK
  ? `${REACT_APP_SERVER_LINK.replace(/\/+$/, "")}/health`
  : "/health";
const INTERVAL_MS = 60000;

/** Polls the API health endpoint once a minute (and when the tab regains focus). */
export const useServerStatus = (): ServerStatus => {
  const [status, setStatus] = React.useState<ServerStatus>("checking");

  React.useEffect(() => {
    let active = true;
    const check = () => {
      fetch(HEALTH_URL, { cache: "no-store" })
        .then((res) => active && setStatus(res.ok ? "online" : "offline"))
        .catch(() => active && setStatus("offline"));
    };
    check();
    const timer = window.setInterval(check, INTERVAL_MS);
    window.addEventListener("focus", check);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", check);
    };
  }, []);

  return status;
};
